/* eslint-disable no-param-reassign */
import axios from 'axios';
import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { store } from '@/redux/store';

import authOperations from '@/redux/auth/authOperations';

const { getState, dispatch } = store; // direct access to redux store

const TIMEOUT_DELAY = 20000;

let isRefreshStarted = false;
let subscribers = [];

const subscribeTokenRefresh = data => subscribers.push(data);
const onAccessTokenRefreshed = token =>
  subscribers.filter(([resolve, cb, delayedAction]) => {
    clearTimeout(delayedAction);
    resolve(cb(token));
  });

const defaults = {
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  withXSRFToken: true,
  timeout: TIMEOUT_DELAY,
};

const $apiPrivate = axios.create(defaults);

$apiPrivate.interceptors.request.use(
  async config => {
    const {
      auth: { accessExpires, accessToken: token },
    } = getState();

    if (!token) {
      dispatch(authOperations.reset());
      return config;
    }

    const accessTimeEnd = new Date(accessExpires).getTime() / 1000;
    const currentTime = Date.now() / 1000;

    const accessTokenLifeLeftSeconds = Math.round(accessTimeEnd - currentTime);

    // Если остаток жизни токена превышает 10 секунд,
    // записываю его в заголовки для выполнения запроса
    if (accessTokenLifeLeftSeconds > 10) {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    }

    if (!isRefreshStarted) {
      isRefreshStarted = true;
      await authOperations.refreshToken();
      isRefreshStarted = false;

      const {
        auth: { accessToken: newToken },
      } = getState();

      config.headers.Authorization = `Bearer ${newToken}`;

      onAccessTokenRefreshed(newToken);

      return config;
    } else {
      const retryConfig = await new Promise(resolve => {
        const cb = newToken => {
          config.headers.authorization = `Bearer ${newToken}`;
          resolve(config);
        };

        const delayedAction = setTimeout(resolve, TIMEOUT_DELAY);

        subscribeTokenRefresh([resolve, cb, delayedAction]);
      });

      return retryConfig;
    }
  },
  error => {
    throw error;
  },
);

$apiPrivate.interceptors.response.use(
  response => response.data,
  error => {
    console.error(error);

    // if (error.message) {
    //   Notify.warning(error.message)
    //   return
    // }

    if (error?.response?.status === 401) {
      Notify.warning('Your session has expired. Please log in again.');
      dispatch(authOperations.reset());
      return;
    }

    throw error;
  },
);

export default $apiPrivate;
